import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IChatMobileProps {
  isOpenInformer: boolean;
  onCloseInformer(): void;
}

export const ChatMobile: React.FC<IChatMobileProps & React.PropsWithChildren> = ({
  children,
  onCloseInformer,
  isOpenInformer,
}) => {
  return (
    <div className={styles['container']}>
      {/*
        OnboardingTooltip специально оборачивает пустой div с размерами иконки чатов,
        так как в children библиотечный компонент иконки чатов с div размером 0х0
      */}
      <OnboardingTooltip
        content={<div className={styles['content']}>Ответим на любые вопросы по услуге «Циан.Сделка»</div>}
        theme="blue"
        open={isOpenInformer}
        placement="top-end"
        onClose={onCloseInformer}
        portal={false}
      >
        <div className={styles['chat-icon']} />
      </OnboardingTooltip>
      {children}
    </div>
  );
};

ChatMobile.displayName = 'ChatMobile';
